import { Home } from "./screens/Home";

function App() {
  return <Home />;
}

export default App;
